import React from 'react'
import { apiFetch } from '../../fetchApi'

export const perferredDetails = ({ BeURL, formData, currentUser, navigate, reverse, previous, candidateId, showAlert }) => {

   
    apiFetch(`${BeURL}/perferredinfromation`, {
        method: 'POST',
        body: JSON.stringify({ formData, candidateId })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                showAlert(data.message)
                if (reverse)
                    navigate(previous)
                else
                    window.location.href=`/update-account/success?candidateId=${candidateId}`
            }
            else {
                showAlert(data.message)
            }
        })
        .catch(err => {
            console.log('Error in Login:', err)
            alert('Trouble in connecting to the Server! Please try again later.')
        })

}
